import axios from 'axios';

type GetPaidAmountFormData = {
    taxpayerCode: string;
};

export const getPaidAmountForm = async (data: GetPaidAmountFormData): Promise<string> => {
    return axios
        .post('/services/isnaportalsync/public/payments', data, {
            headers: {
                'X-Portal-Token': 'd0165516-04e0-4d5c-961a-18d45b8259ea',
                Accept: 'application/xml',
                'Content-Type': 'application/json',
            },
        })
        .then(({ data }) => data);
};

type SendPaidAmountFormData = {
    signedRequest: string;
    taxpayerCode: string;
};

export const sendPaidAmountForm = async ({
    signedRequest,
    taxpayerCode,
}: SendPaidAmountFormData) => {
    return axios.post(
        '/services/isnaportalsync/public/payments',
        { taxpayerCode, signedRequest },
        {
            headers: {
                'X-Portal-Token': 'd0165516-04e0-4d5c-961a-18d45b8259ea',
            },
        }
    );
};
